<template>
  <BaseListPage
      :name="name"
      :no-condition="false"
      :base-query="baseQuery"
      :store-path="storePath"
      :response-path="responsePath"
      :save-key="saveKey"
      :is-parent-loaded="isParentLoaded"
      :table-set-list="tableSetList"
      :table-data-list="sortedList"
      title="アカウント一覧"
      title-class="account-header"
      icon="account"
      table-class="row-clickable-table"
      @row-click="onRowClick">
    <span slot="headerAction"
        class="action_button">
      <el-dropdown
          v-show="$isFunctionShown(define.PermissionKeys.Account.Account.Detail.NEW)"
          @command="actionCommand">
        <el-button size="small">
          アクション
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu
            slot="dropdown"
            class="header-action-menu">
          <el-dropdown-item
              :disabled="$isFunctionDisabled(define.PermissionKeys.Account.Account.Detail.NEW)"
              :command="define.ACCOUNT_MODE.NEW">
            新規登録
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </BaseListPage>
</template>

<script>

import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'
import * as define from '@/define'
import * as query from '@/queries/account'
import permissionRole from '@/store/pages/permissionRole'
import siteRole from '@/store/pages/siteRole'

import x from '@/components/mixins/mixin'
import BaseListPage from '@/components/organisms/BaseListPage'

export default {
  name: 'AccountList',
  components: {
    BaseListPage
  },
  mixins: [x],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      localIsParentLoaded: false
    }
  },
  computed: {
    define: () => define,
    ...mapState({
      listIndex: (state) => state.Account.listIndex,
      tableSetList: (state) => state.Account.tableSetList,
      siteRoleOptions: (state) => state.SiteRole.siteRoleOptions,
      permissionRoleOptions: (state) => state.PermissionRole.permissionRoleOptions
    }),
    ...mapGetters({
      getSortedList: 'sortedList',
      getAccountTypeOptions: 'getAccountTypeOptions'
    }),
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    name () {
      return 'accountList'
    },
    storePath () {
      return 'Account'
    },
    saveKey () {
      return 'accountCondition'
    },
    responsePath () {
      return 'data.accounts'
    },
    linkKey () {
      return 'uuid'
    },
    returnPath () {
      return '/account'
    },
    baseQuery () {
      return query.GRAPH_QL_QUERY_ACCOUNT_LIST
    },
    sortedList () {
      return this.getSortedList(this.storePath, this.sortCondition(this.name))
    },
    _tableSetList () {
      return [
        { type: 'String', label: 'アカウント名', path: 'account', sortable: 'custom', funcId: define.PermissionKeys.Account.Account.List.ACCOUNT },
        {
          type: 'String', label: '権限タイプ', path: 'type',
          selectCode: () => {
            if (typeof this.isSystemAccount === 'function' && this.selectAccountTypeOptions()) {
              if (typeof this.isSystemAccount === 'function' && this.isSystemAccount()) {
                return this.selectAccountTypeOptionsALL()
              } else {
                return this.selectAccountTypeOptions()
              }
            } else { return [] }
          },
          codeName: (code) => {
            return (this.getAccountTypeOptions().find(element => code === element.code) || {}).name
          }
        },
        { type: 'String', label: 'サイトロール', path: 'siteRole.name', sortable: 'custom', funcId: define.PermissionKeys.Account.Account.List.SITE_ROLE },
        { type: 'String', label: '権限ロール', path: 'permissionRole.name', sortable: 'custom', funcId: define.PermissionKeys.Account.Account.List.PERMISSION_ROLE }
      ]
    },
    isParentLoaded () {
      return this.localIsParentLoaded
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      this.$store.dispatch({
        type: 'set',
        states: {
          'Account/tableSetList': this._tableSetList
        }
      })

      // サイトロールと権限ロールの選択肢取得(未取得の時実施される)
      await Promise.all([
        siteRole.getSiteRoleOptions(),
        permissionRole.getPermissionRoleOptions()
      ])
      // リストの選択肢の設定
      this.$store.dispatch({
        type: 'set',
        states: {
          'Account/searchConditions/siteRoleUuid/options': this.siteRoleOptions,
          'Account/searchConditions/permissionRoleUuid/options': this.permissionRoleOptions,
          'Account/searchConditions/accountType/options': this.getAccountTypeOptions()
        }
      })

      this.localIsParentLoaded = true
    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    onRowClick (row, column, event) {
      const id = _.get(row, this.linkKey)
      const index = this.$_mixin_findIndex(this.sortedList, { [this.linkKey]: id })
      this.$_mixin_onLinkClick(index, this.storePath)
      this.$router.push({ path: `/account/${id}` })
    },
    /**
     * アクションボタン
     * @param {Number} mode モード
     */
    actionCommand: async function (mode) {
      switch (mode) {
        case define.ACCOUNT_MODE.NEW:
          this.createAccount()
          break
        default:
          break
      }
    },
    createAccount () {
      this.$_mixin_onLinkClick(this.listIndex, this.storePath, define.ACCOUNT_MODE.NEW)
      this.$router.push({ path: 'account/0' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/account/AccountListTop.vue